export const typeUserManagment = (typeUser) => {
  if (typeUser === "Admin") {
    return undefined;
  }
  if (typeUser === "Special customer") {
    return "2";
  }
  return "1";
};
